import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import theme from './theme'
import './Global.Styled'
import Home from './components/Home/Home'
import Kandi from './components/Kandi/Kandi'
import NewsAlarm from './components/Topic/NewsAlarm/NewsAlarm'
// import ProgramPage from './components/Topic/Program/ProgramPage'
// import TileCubeDemo from './components/Home/TileCubeDemo'
// import FoldingCubeDemo from './components/Home/FoldingCubeDemo'
// import ClampCubeDemo from './components/Home/ClampCubeDemo'
// import GifCubeDemo from './components/Home/GifCubeDemo'
// import ParteitagCubeDemo from './components/Home/ParteitagCubeDemo'
// import DropCubeDemo from './components/Home/DropCubeDemo'
import OlafTourPage from './components/Topic/OlafTour/OlafTourPage'
import Topic from './components/Topic/Topic/Topic'

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            {/* home */}
            <Route index element={<Home />} />
            {/* <Route path="gif" element={<GifCubeDemo />} />
            <Route path="tiles" element={<TileCubeDemo />} />
            <Route path="folding" element={<FoldingCubeDemo />} />
            <Route path="clamp" element={<ClampCubeDemo />} />
            <Route path="parteitag" element={<ParteitagCubeDemo />} />
            <Route path="drop" element={<DropCubeDemo />} /> */}

            {/* kandi */}
            <Route path="wk/:wahlkreisID" element={<Kandi />} />

            {/* topic */}
            <Route path="tp/:topicID" element={<Topic />} />

            {/* pages */}
            <Route path="newsalarm" element={<NewsAlarm />} />
            {/* <Route path="programm" element={<ProgramPage />} /> */}
            <Route path="olaf" element={<OlafTourPage />} />

            {/* fallback routing */}
            <Route path={'*'} element={<Navigate replace to="/" />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </div>
  )
}

export default App
